<template lang="pug">
  v-list
    v-list-item(
      v-for="option in value.possible_answers"
      :key="option.id"
    )
      v-list-item-action
        template(v-if="!analytic")
          v-icon(
            v-if="option.user_selected"
            :color="getIconColor(option)"
          ) {{ getAnswerIcon(option) }}
          v-icon(
            v-else-if="option.correct_answer"
            color="warning"
          ) mdi-minus-thick
        template(v-else)
          .d-flex.align-center
            tooltip-wrap(
              v-if="option.total_current_user_choice !== undefined"
              text="Ответы ученика"
            )
              v-chip(:color="`${getOptionColor(option)} lighten-4`").chip-stat.mr-3
                v-icon(color="secondary" left) mdi-account
                span.secondary--text {{ option.total_current_user_choice }}
            tooltip-wrap(
              text="Ответы всех учеников"
            )
              v-chip(:color="`${getOptionColor(option)} lighten-4`").chip-stat
                v-icon(color="secondary" left) mdi-account-group-outline
                span.secondary--text {{ option.total_user_choice }}

            tooltip-wrap(
              text="Насколько часто выбирают этот вариант ответа"
            )
              v-progress-circular(
                width="3"
                size="50"
                color="secondary"
                :value="getChoicePercent(option)"
              ).ml-5
                strong.caption.secondary--text {{ getChoicePercent(option) }}%
      v-list-item-content
        v-list-item-title {{ option.name }}
        v-list-item-subtitle(
          v-if="option.correct_answer"
        ).success--text Правильный вариант
</template>

<script>
export default {
  name: 'TypeOneOfMany',
  props: {
    task: { type: Object, default: null },
    value: {
      type: Object,
      default: () => ({}),
    },
    analytic: {
      type: Boolean, default: false,
    },
  },
  methods: {
    getChoicePercent(option) {
      if (this.task.total_journals === 0) return 0;

      return Math.round(
        option.total_user_choice * (100 / this.task.total_journals),
      );
    },
    getOptionColor(option) {
      return option.correct_answer ? 'success' : 'error';
    },
    getAnswerIcon(answer) {
      return answer.user_selected && answer.correct_answer ? 'mdi-check' : 'mdi-close';
    },
    getIconColor(answer) {
      return answer.user_selected === answer.correct_answer ? 'success' : 'error';
    },
  },
};
</script>

<style lang="scss" scoped>
.chip-stat {
  width: 80px;
  display: flex;
  justify-content: center;
}
</style>
